/**
 * 
 * @param {string} tag 
 * @param {object} attributes 
 * @returns HTMLNode
 */
export function createElement (tag, attributes) {
    let el = document.createElement(tag);
    for (const x in attributes) {
        // Attach event via 'on_eventType', e.g. 'on_click'
        const checkX = x.split('_');
        if(checkX[0]=='on'){
            el.addEventListener(checkX[1], attributes[x]);            
            continue;
        }
        if (typeof attributes[x] == 'object') {
            for (const y in attributes[x]) {
                el[x][y] = attributes[x][y];
            }
        } else {
            el[x] = attributes[x];
        }
    }
    return el;    
}

/**
 * 
 * @param {any} answer 
 * @returns 1 or 0
 */
export function isAnswered (answer) {
    return Array.isArray(answer) ? (answer.length ? 1 : 0) : (answer ? 1 : 0);                
}

/**
 * 
 * @param {object} e 
 */
export function countAnswer (e, instance) {
    if(instance.mode == 2){
        const el = e.target;
        let type = 'a';
        if(el.nodeName == 'INPUT' && (el.type == 'radio' || el.type == 'checkbox')) type = 'b';
        const name = el.name;
        const parent = el.closest('.x-component');
        const selected = parent.querySelector('input[name="'+name+'"]:checked');
        const plus = (type=='a' ? el.value : selected) && !parent.dataset.answered;
        const minus = (type=='a' ? !el.value : !selected) && parent.dataset.answered; 
        if(plus){
            instance.curValue.innerText = parseInt(instance.curValue.innerText) + 1;
            parent.dataset.answered = 1;
        }

        if(minus){
            instance.curValue.innerText = parseInt(instance.curValue.innerText) - 1;
            delete parent.dataset.answered;
        }
    }
}

/**
 * 
 * @param {HTMLNode} parentElement 
 * @returns object
 */
export function calculateChoicePoints (parentElement) {
    const result = {};
    const choicePoints = parentElement.querySelectorAll('.x-choice-point');        
    if(choicePoints) {
        result.choice_points = Array.from(choicePoints).map(el => {
            return parseInt(el.innerText);
        });
        result.total_choice_points = result.choice_points.reduce((total, n) => {
            return total + n;
        }, 0);
        result.max_choice_points = result.choice_points.reduce((prev, current) => {
            return prev > current ? prev : current;
        }, 0);
    }
    return result;
}

/**
 * 
 * @param {object} e 
 */
export function numberOnly (e) {
    const charCode = e.which ? e.which : e.keyCode;
    // Only allow numeric keys and backspace (8), tab (9)
    if (charCode == 13 || (charCode > 31 && (charCode < 48 || charCode > 57))) {
        e.preventDefault();
    }        
}

/**
 * 
 * @param {array} array 
 * @returns shuffled array
 */
export function shuffleArray (array) {
    if (!Array.isArray(array)) {
        throw new TypeError("Argument should be an array");
    }

    let arr = array.slice();

    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }

    return arr;
}

/**
 * 
 * @param {string} message 
 * @param {integer} delay 
 * @returns void
 */
export function notify(message, delay = 3000) {
    if(!message) return;
    let dialog = document.querySelector('.x-dialog');
    if(!dialog) {
        dialog = createElement('div', {
            className: 'x-dialog'
        })    
        document.body.appendChild(dialog);
    }
    dialog.innerText = message;
    dialog.classList.add('show');
    setTimeout(()=>{ dialog.classList.remove('show'); }, delay);
}
